import { render, staticRenderFns } from "./Step2Overview.vue?vue&type=template&id=1321b3cd&scoped=true&"
import script from "./Step2Overview.vue?vue&type=script&lang=js&"
export * from "./Step2Overview.vue?vue&type=script&lang=js&"
import style0 from "./Step2Overview.vue?vue&type=style&index=0&id=1321b3cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1321b3cd",
  null
  
)

export default component.exports